import { render, staticRenderFns } from "./UserFormChild.vue?vue&type=template&id=2b8540ad&scoped=true&"
import script from "./UserFormChild.vue?vue&type=script&lang=js&"
export * from "./UserFormChild.vue?vue&type=script&lang=js&"
import style0 from "./UserFormChild.vue?vue&type=style&index=0&id=2b8540ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8540ad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b8540ad')) {
      api.createRecord('2b8540ad', component.options)
    } else {
      api.reload('2b8540ad', component.options)
    }
    module.hot.accept("./UserFormChild.vue?vue&type=template&id=2b8540ad&scoped=true&", function () {
      api.rerender('2b8540ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UserFormChild.vue"
export default component.exports